(function() {
    angular.module('bpub', ['ngCookies', 'ngMessages', 'ngMap', 'ngSanitize', 'ngPointer', 'ngMaterial','ui.router','angular-intro'/* ,'templateCache' */])
    .config(['$stateProvider', '$mdGestureProvider', '$urlRouterProvider', '$mdThemingProvider', '$mdIconProvider', '$locationProvider', '$qProvider', 
     function($stateProvider, $mdGestureProvider, $urlRouterProvider, $mdThemingProvider, $mdIconProvider, $locationProvider, $qProvider) {
        $mdThemingProvider.theme('default')
            .primaryPalette('blue', {'default': '900'});
        $mdIconProvider.defaultIconSet('../images/mdi.svg');
        $urlRouterProvider.otherwise('/');
        $qProvider.errorOnUnhandledRejections(false);
        $mdGestureProvider.skipClickHijack();
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
        $stateProvider.state('assist', {
            url: '/',
            controller: 'assistCtrl',
            templateUrl: '/templates/index.html'
        }).state('issue', {
            url: '/issue/:type',
            controller: 'issueCtrl as ctrl',
            templateUrl: '/templates/issue.html'
        }).state('asset', {
            url: '/asset/:type',
            controller: 'assetCtrl as ctrl',
            templateUrl: '/templates/asset.html'
        }).state('help', {
            url: '/help',
            controller: 'helpCtrl as ctrl',
            templateUrl: '/templates/help.html'
        }).state('terms', {
            url: '/terms',
            controller: 'termsCtrl as ctrl',
            templateUrl: '/templates/terms.html'
        }).state('privacy', {
            url: '/privacy',
            controller: 'privacyCtrl as ctrl',
            templateUrl: '/templates/privacy.html'
        });

    }]);
})();

(function() {
    'use strict';
    var assistCtrl = function ($scope, $state, $mdDialog, storage, assistFactory) {
        var version = '2.0.1';
        console.log('BPUB Assist v' + version);
        var ie10andbelow = navigator.userAgent.indexOf('MSIE') !== -1;

        if(ie10andbelow) {

            var alert = $mdDialog.confirm()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Upgrade Recommended')
                .textContent('In order to get the best performance we recommend you upgrade your Internet Explorer to the latest version.  Or you could also use Google Chrome or Firefox.')
                .ariaLabel('Upgrade')
                .ok('Close')
                .cancel('Get IE 11');
            $mdDialog.show(alert).then(function() {

            }, function() {
                window.location = "http://go.microsoft.com/fwlink/?linkid=282703";
            });
        }

        if(localStorage) {
            var global = storage.getAll();
            if(global === null) {
                storage.new();
            }
        }
        $scope.user = {
            email: '',
            comments: ''
        };
        $scope.appTitle = 'BPUB';
        $scope.showTweet = false;
        $scope.bannerShow = true;
        $scope.maintenance = false;
        $scope.tweet = '';
        $scope.maintenancetext = '';
        $scope.link = [
            {
                id: 'billpay',
                url: "https://www.invoicecloud.com/brownsvilletx",
                src: "/images/dist/icons/bill.png",
                aria: "Bill Pay"
            },
            {
                id: 'Electric',
                url: 'Electric',
                type: 'issue',
                src: '/images/dist/icons/power.png',
                aria: 'Electric'
            },
            {
                id: 'Water',
                url: 'Water',
                type: 'issue',
                src: '/images/dist/icons/water.png',
                aria: 'Water'
            },
            {
                id: 'WasteWater',
                url: 'WasteWater',
                type: 'issue',
                src: '/images/dist/icons/sewer.png',
                aria: 'Wastewater'
            },
            {
                id: 'Hydrant',
                url: 'Hydrant',
                type: 'asset',
                src: '/images/dist/icons/hydrant.png',
                aria: 'Fire Hydrant'
            },
            {
                id: 'Lights',
                url: 'Lights',
                type: 'asset',
                src: '/images/dist/icons/street-lights.png',
                aria: 'Street/Security Lights'
            },
            {
                id: 'Poles',
                url: 'Poles',
                type: 'asset',
                src: '/images/dist/icons/street-lights.png',
                aria: 'Poles'
            },
            {
                id: 'Trash',
                url:'mailto',
                urls: 'mailto:546HELP@cob.us?subject=Trash/Brush',
                src: '/images/dist/icons/trash.png',
                aria: 'Trash'
            }
            ,
            {
                id: 'Trees',
                url:'Tree',
                type: 'issue',
                src: '/images/dist/icons/tree.png',
                aria: 'Trees'
            }
        ];

        $scope.issue = function (params) {
            $state.go('issue', {type: params});
        };

        $scope.asset = function (params) {
            $state.go('asset', {type: params});
        };

        $scope.public = function() {
            location.href = 'http://www.brownsville-pub.com';
        };

        $scope.bannerClick = function() {
            if($scope.bannerShow) {
                $scope.bannerShow = false;
            }
        };

        $scope.clicked = function(link) {
           
            var reg = /http/;
            var mail = /mailto/;
            if(reg.test(link.url)) {
                location.href = link.url;
            } else if(mail.test(link.url)) {
                let parent = angular.element(document.body);
                $mdDialog.show({
                    parent: parent,
                    targetEvent: link,
                    clickOutsideToClose: false,
                    scope: $scope,
                    preserveScope: true,
                    templateUrl: '/templates/trash.html',
                    controller: ['$scope','$state','$mdDialog','assistFactory', function DialogController($scope, $state, $mdDialog, assistFactory) {
                        $scope.assistFact = assistFactory;
                        $scope.cancel = function () {
                            $scope.user.comments = '';
                            $scope.user.email = '';
                            $mdDialog.hide();
                        }
                        $scope.send = function () {
                            //console.log($scope.user);
                            $scope.assistFact.trash($scope.user).then(function (response) {
                                console.log(response);
                                if (response.data === 'ok') {
                                    $mdDialog.hide();
                                    var alert = $mdDialog.alert({
                                        title: 'Success!',
                                        textContent: 'Your message was sent successfully.',
                                        ok: 'Done'
                                    });
                                    $mdDialog.show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                } else {
                                    user.comments = '';
                                    user.email = '';
                                    $mdDialog.hide();
                                    var alert = $mdDialog.alert({
                                        title: 'Error',
                                        textContent: 'We apologize for the inconvenience, there was an error sending your message.  Please call 956-546-4357 to further assist you.',
                                        ok: 'OK'
                                    });
                                    $mdDialog.show(alert)
                                        .finally(function () {
                                            alert = undefined
                                        });
                                }
                            });
                        };
                    }]
                });
            } else {
                $state.go(link.type, {type: link.url});
            }
        };

        

        $scope.help = function () {
            location.href = 'http://newsroom.brownsville-pub.com/app/bpub-app.html';
        };

        assistFactory.tweets().then(function(data) {

            if(data.text) {
                const createdAt = dateDiff(data.created_at);
                let chars = createdAt.match(/[a-z]+/g);
                let nums = createdAt.match(/\d+/g);

                if (nums[0] > 24 && chars[0] === 'h') { 
                    // don't show tweet, past 24 hours
                    return;
                }
                $scope.showTweet = true;
                var dateText = ' - posted: ' + createdAt + ' ago';
                $scope.tweet = data.text.concat(dateText);
            }
        }, function(err) {
            console.error(err);
        });

        assistFactory.maintenance().then(function(d) {
            if (d.data.text) {
                $scope.maintenance = true;
                $scope.maintenancetext = d.data.text;
            }
        });

        function dateDiff(date) {
            var diff = new Date() - new Date(date);
            var hrs = parseInt(Math.abs(diff) / 3600000) + 'h';
            if(parseInt(hrs) < 1) {
                hrs = parseInt(Math.floor((diff) % 3600000) / 60000) + 'm';
            }
            return hrs;
        }

    };
	angular.module('bpub').controller('assistCtrl', ['$scope', '$state', '$mdDialog', 'storage', 'assistFactory', assistCtrl]);
})();
'use strict';
(function() {

    var assetCtrl = function ($scope, $state, $mdToast, $timeout, $mdMedia, $mdDialog, $q, $mdSidenav, $stateParams, NgMap, assetFactory, storage) {

        var vm = this;

        if ($stateParams.type === '') {
            $state.go('assist');
        }

        vm.type = $stateParams.type;
        vm.showControl = false;
        if (vm.type === 'Hydrant') {
            vm.reportType = 'Hydrant';
            vm.asset = 'hydrant';
        }else if (vm.type === 'Poles') {
            vm.reportType = 'Poles';
            vm.asset = 'pole';
        } 
        else {
            vm.reportType = 'Lights';
            vm.asset = 'light';
        }
        vm.input = document.getElementById('autocomplete');
        NgMap.getMap().then(function (map) {

            vm.map = map;
            $timeout(function () {
                vm.map.controls[google.maps.ControlPosition.TOP_LEFT].push(vm.input);
                vm.showControl = true;
            }, 1500)

            vm.map.setCenter(new google.maps.LatLng(25.9017, -97.4975));
            vm.IntroOptions = {
                steps: [{
                        element: document.querySelector('#gps'),
                        intro: '<p style="text-align: center;">Tap on this GPS icon to get your current location.  This functionality requires that location services are enabled on your device.</p>',
                        position: 'bottom-left-aligned'

                    },
                    {
                        element: document.querySelector('#address'),
                        intro: '<p style="text-align: center;">Or you can type in an address.  If you need additional assistance visit our <a href="/help">help center.</a></p>',
                        position: 'bottom-middle-aligned'

                    }
                ],
                showStepNumbers: false,
                exitOnOverlayClick: true,
                exitOnEsc: true,
                nextLabel: '<strong>Next</strong>',
                prevLabel: 'Prev',
                showBullets: false,
                doneLabel: '<strong>OK, Got It!</strong>'
            };

            vm.gmapsService = new google.maps.places.AutocompleteService();
            vm.placeService = new google.maps.places.PlacesService(vm.map);
            vm.gmapsService.bindTo('bounds', vm.map);
            google.maps.event.trigger(vm.map, 'resize');
        });
        $scope.$watch(function () {
            return $mdMedia('gt-md');
        }, function (obj) {
            vm.i = obj;
        });
        vm.issue = vm.type.toLowerCase();
        vm.myIcon = {
            url: '/images/dist/ic_location.png',
            anchor: [12, 12],
            origin: [0,0],
            id: 'currentPosition'
        };
        vm.red = {
            url: '/images/dist/red_18_x_18.png',
            size: [18, 18],
            origin: [0, 0],
            anchor: [0, 18]
        };
        vm.blue = {
            url: '/images/dist/blue_18_x_18.png',
            size: new google.maps.Size(50, 50),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 18)
        };
        vm.poletag = '';
        vm.category = '';
        vm.radio = '';
        vm.location = '';
        vm.selectedItem = '';
        vm.comments = '';
        vm.markers = [];
        vm.infoWinArray = [];
        vm.positions = [];
        vm.polepositions = [];
        vm.miniSize = false;
        vm.showProgress = false;
        vm.showSpinner = false;
        vm.selected = false;
        vm.toggleLeft = toggleLeft;
        vm.getItemInfo = getItemInfo;
        vm.getLocation = getLocation;
        vm.getAssets = getAssets;
        vm.zoom = zoom;
        vm.dragend = dragend;
        vm.clearMap = clearMap;
        vm.home = goHome;
        vm.help = goHelp;
        vm.getResults = getResults;
        vm.search = search;
        vm.selectedItemChange = selectedItemChange;
        vm.showDetail = showDetail;
        vm.submitForm = submitForm;
        vm.getIssueRadios = getIssueRadios;
        vm.cancel = cancel;
        vm.textMe = textMe;
        vm.voiceMe = voiceMe;
        vm.saveInfo = saveInfo;
        vm.yes = yes;
        vm.setIssue = setIssue;
        vm.isOpenLeft = isOpenLeft;
        vm.closeLeft = closeLeft;
        vm.closeInfWin = closeInfWin;
        vm.showPrompt = showPrompt;
        vm.showRem = showRem;
        vm.cookie = {};
        vm.getCookie = getCookie;
        vm.issueObj = {};
        vm.issueList = {
            'streetlight': [{
                    'display': 'Streetlight Out',
                    'value': 37
                },
                {
                    'display': 'Streetlight Blinking',
                    'value': 14282
                },
                {
                    'display': 'Dim Streetlight',
                    'value': 14283
                },
                {
                    'display': 'Streetlight Always On',
                    'value': 5140
                },
                {
                    'display': 'Damaged Streetlight Cover',
                    'value': 14284
                },
                {
                    'display': 'Missing Streetlight Cover',
                    'value': 14285
                }
            ],
            'securitylight': [{
                    'display': 'Damaged Security Light Cover',
                    'value': 14280
                },
                {
                    'display': 'Missing Security Light Cover',
                    'value': 14281
                },
                {
                    'display': 'Security Light Blinking',
                    'value': 13502
                },
                {
                    'display': 'Security Light Dim',
                    'value': 14279
                },
                {
                    'display': 'Security Light Always On',
                    'value': 13499
                },
                {
                    'display': 'Security Light Out',
                    'value': 14277
                }
            ],
            'hydrant': [{
                    'display': 'Hydrant Leaking',
                    'value': 14321
                },
                {
                    'display': 'Damaged/Broken Hydrant',
                    'value': 14322
                },
                {
                    'display': 'No Water at Fire Hydrant',
                    'value': 14323
                },
                {
                    'display': 'Open Hydrant',
                    'value': 14324
                },
                {
                    'display': 'Other Hydrant Problem',
                    'value': 14325
                }
            ],
            'alleylight': [{
                    'display': 'Alley Light Blinking',
                    'value': 13498
                },
                {
                    'display': 'Alley Light Always On',
                    'value': 13500
                },
                {
                    'display': 'Alley Light Out',
                    'value': 14242
                },
                {
                    'display': 'Alley Light Dim',
                    'value': 14243
                },
                {
                    'display': 'Damaged Alley Light Cover',
                    'value': 14244
                },
                {
                    'display': 'No Alley Light Cover',
                    'value': 14245
                }
            ],
            'poles': [{
                    'display': 'Radio Frequency Interface',
                    'value': 18886
                },
                {
                    'display': 'Broken Insulator',
                    'value': 19244
                },
                {
                    'display': 'Broken Ground Wire',
                    'value': 19245
                },
                {
                    'display': 'Missing Ground Wire',
                    'value': 19246
                },
                {
                    'display': 'Other Pole Problem',
                    'value': 18649
                }
            ]
        };
        vm.showSimpleToast = function (text) {
            $mdToast.show(
                $mdToast.simple()
                .textContent(text)
                .position('bottom left')
                .hideDelay(3000)
            );
        };
        vm.getPole = function (params) {

            assetFactory.getPole(params).then(function (response) {

                plotPoles(response.data);
            }, function (err) {
                console.log(err.message);
            });
        };

        /* Functions */

        function showRem() {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(true)
                .title('Remember Me')
                .textContent('When you opt in, you allow BPUB Assist to provide you with a more personalized experience.  If you check Rememeber Me, we will make it easier pre-populating fields you choose to save.  This option is NOT recommended if you are using a public or shared computer.')
                .ariaLabel('Remember Me')
                .ok('OK')
            );
        }

        function showMessage(title, text, aria) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(title)
                .textContent(text)
                .ariaLabel(aria)
                .ok('OK')
            );
        }

        function showAlert(title, text) {
            var alert = $mdDialog.alert({
                title: title,
                textContent: text,
                ok: 'OK'
            });
            $mdDialog.show(alert).finally(function () {
                alert = undefined;
            });
        }

        function showError(error) {
            var alert = $mdDialog.alert({
                    title: error.title,
                    textContent: error.message,
                    ok: 'OK'
                })
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .ariaLabel('Error');
            $mdDialog.show(alert).then(function () {
                //$state.go('assist');
            });
        }

        function setIssue() {
            vm.issueObj = {
                value: vm.radio.value,
                display: getDisplay(vm.radio.value)
            }
        }

        function getDisplay(value) {
            if (vm.issue === 'Streetlight') {
                var st = vm.issueList.streetlight.filter(getDisplayByValue, value)[0];
                return st.display;
            }

            if (vm.issue === 'Securitylight') {
                var se = vm.issueList.securitylight.filter(getDisplayByValue, value)[0];
                return se.display;
            }

            if (vm.issue === 'Alleylight') {
                var al = vm.issueList.alleylight.filter(getDisplayByValue, value)[0];
                return al.display;
            }

            if (vm.issue === 'Hydrant') {
                var hy = vm.issueList.hydrant.filter(getDisplayByValue, value)[0];
                return hy.display;
            }

            if (vm.issue === 'Poles') {
                var po = vm.issueList.poles.filter(getDisplayByValue, value)[0];
                return po.display;
            }
        }

        function getDisplayByValue(obj) {
            var t = Object(this);
            if (obj.value == t) {
                return obj;
            }
        }

        function submitForm() {

            if (vm.issue === 'Poles' && vm.issueObj.value === 18649 && (!vm.comments || vm.comments.trim() === '')) {
                showAlert('Comments', 'Please provide additional details for Other Pole Problem.');
                vm.submitDisabled = false;
                return;
            }

            var serialized = {
                name: vm.name,
                phone: vm.phone,
                account: vm.account,
                email: vm.email === '' ? 'notvalid@brownsville-pub.com' : vm.email,
                comment: vm.comments,
                issue: vm.issueObj,
                text: vm.text,
                voice: vm.call,
                service_type: vm.issue,
                gis: {
                    objectid: vm.place.objectid,
                    poletag: vm.place.poleref,
                    address: vm.place.address,
                    x: vm.place.coord.x,
                    y: vm.place.coord.y
                }
            };

            $mdDialog.show({
                clickOutsideToClose: false,
                scope: $scope,
                preserveScope: true,
                templateUrl: '/templates/dialog.html',
                controller: ['$scope', '$state', '$mdDialog', 'assetFactory', function DialogController($scope, $state, $mdDialog, assetFactory) {

                    $scope.cwJsonObj = serialized;
                    $scope.assetFact = assetFactory;
                    $scope.activated = true;
                    $scope.error = false;
                    $scope.showOk = false;
                    $scope.showWait = true;
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                        $state.go('assist');
                    };

                    $scope.assetFact.process($scope.cwJsonObj).then(function (response) {
                        var data = response.data;

                        if (data.error) {
                            showError(data.error);
                            return;
                        }

                        if (data.limit_reached === true) {
                            $scope.limitReached = true;
                            $scope.showWait = false;
                            $scope.showOk = true;
                        } else {
                            $scope.showWait = false;
                            $scope.activated = false;
                            $scope.id = data.id;
                            $scope.showOk = true;
                        }
                    });
                }]
            });
        }

        function goHelp() {
            vm.map.hideInfoWindow('iw');
            vm.map.hideInfoWindow('reported');
            vm.positions = [];
            $state.go('help');
        }

        function closeInfWin(infWin) {

            vm.map.hideInfoWindow(infWin);
            vm.location = '';
            $mdToast.show(
                $mdToast.simple()
                .textContent('Drag the map and then tap on the correct icon.')
                .position('bottom')
                .hideDelay(7000)
            );
        }

        function isOpenLeft() {
            return $mdSidenav('left').isOpen();
        }

        function closeLeft() {
            $mdSidenav('left').close();
        }

        function toggleLeft() {
            $mdSidenav('left').open();
        }

        function getIssueRadios() {
            if (vm.issue === 'Streetlight') {
                return vm.issueList.streetlight;
            } else if (vm.issue === 'Securitylight') {
                return vm.issueList.securitylight;
            } else if (vm.issue === 'Alleylight') {
                return vm.issueList.alleylight;
            } else if (vm.issue === 'Hydrant') {
                return vm.issueList.hydrant;
            } else if (vm.issue === 'Poles') {
                return vm.issueList.poles;
            }
        }

        function getLocation() {

            if (!navigator.geolocation) {
                showMessage('Error', 'Your browser is outdated and does not support Geolocation.  Please upgrade your browser or simply type in the affected address.', 'Error GPS');
                return;
            }

            function success(position) {

                var location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                vm.myPosition = [location.lat(), location.lng()];
                vm.map.panTo(location);
                vm.map.setZoom(19);
                vm.getAssets();
            }

            function error(err) {

                if (err.code === 3)
                    return;

               showMessage('No GPS', 'Please check if you have GPS or location services enabled on your device, then restart your browser.', 'No GPS');

            }

            navigator.geolocation.getCurrentPosition(success, error, {
                enableHighAccuracy: true,
                timeout: 10 * 1000
            });
        }

        function getCookie() {

            vm.cookie = storage.getAll();
            if (vm.cookie !== null) {
                if (vm.cookie.tutorial) {
                    promptTutorial();
                } else {
                    vm.name = vm.cookie.name;
                    vm.phone = vm.cookie.phone;
                    vm.account = vm.cookie.account;
                    vm.email = vm.cookie.email;
                    vm.tutorial = vm.cookie.tutorial;
                    vm.save = (vm.cookie.name && vm.cookie.phone) ? vm.cookie.save : false;
                    vm.text = (vm.cookie.phone) ? vm.cookie.text : false;
                    if (vm.cookie.call === undefined) {
                        vm.cookie.call = false;
                        vm.call = false;
                        storage.save(vm.cookie);
                    } else {
                        vm.call = (vm.cookie.phone) ? vm.cookie.call : false;
                    }
                }
            } else {
                promptTutorial();
            }
        }

        function clear() {
            var tmp = storage.getAll();
            for (var key in tmp) {
                if (key === 'name' || key === 'phone' || key === 'account' || key === 'email' || key === 'save' || key === 'text' || key === 'call') {
                    delete tmp[key];
                }
            }
            vm.name = '';
            vm.phone = '';
            vm.account = '';
            vm.email = '';
            vm.save = false;
            vm.text = false;
            vm.call = false;
            vm.cookie = tmp;
            storage.save(vm.cookie);
        }

        function promptTutorial() {
            var confirm = $mdDialog.confirm()
                .title('Welcome')
                .textContent("Looks like you haven't been here before, would you like some help getting started?")
                .ariaLabel('Confirm')
                .ok("Yes!")
                .cancel('No, Thanks');
            $mdDialog.show(confirm).then(function () {
                vm.cookie.tutorial = false;
                storage.save(vm.cookie);
                $scope.CallMe();
            }, function () {
                vm.cookie.tutorial = false;
                storage.save(vm.cookie);
            });
        }

        function textMe() {
            if (vm.phone === undefined || vm.phone === '') {
                showAlert('Missing Info', 'Please enter a valid 10 digit phone number.');
                vm.text = false;
            } else {
                if (!vm.text) {
                    var confirm = $mdDialog.confirm()
                        .title('Confirm')
                        .textContent("Are you sure you do not want to be notified via Text?")
                        .ariaLabel('Confirm')
                        .ok("Yes, I'm sure")
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function () {
                        vm.cookie.text = false;
                        storage.save(vm.cookie);
                    }, function () {
                        vm.cookie.text = true;
                        storage.save(vm.cookie);
                    });
                } else {
                    vm.cookie.text = true;
                    storage.save(vm.cookie);
                }
            }
        }

        function voiceMe() {
            if (vm.phone === undefined || vm.phone === '') {
                showAlert('Missing Info', 'Please enter a valid 10 digit phone number.');
                vm.call = false;
            } else {
                if (!vm.call) {
                    var confirm = $mdDialog.confirm()
                        .title('Confirm')
                        .textContent("Are you sure you do not want to be notified via voice call?")
                        .ariaLabel('Confirm')
                        .ok("Yes, I'm sure")
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function () {
                        vm.cookie.call = false;
                        storage.save(vm.cookie);
                    }, function () {
                        vm.cookie.call = true;
                        storage.save(vm.cookie);
                    });
                } else {
                    vm.cookie.call = true;
                    storage.save(vm.cookie);
                }
            }
        }

        function saveInfo() {
            if (vm.name) {
                if (vm.phone) {
                    if (vm.save) {
                        vm.cookie.name = vm.name;
                        vm.cookie.phone = vm.phone;
                        vm.cookie.account = vm.account;
                        vm.cookie.email = vm.email;
                        vm.cookie.save = vm.save;
                        vm.cookie.text = vm.text;
                        vm.cookie.call = vm.call;
                        storage.save(vm.cookie);
                    } else {
                        var confirm = $mdDialog.confirm()
                            .title('Confirm')
                            .textContent('Are you sure you wish to remove saved information?')
                            .ariaLabel('Confirm deletion')
                            .ok('Yes')
                            .cancel('No');
                        $mdDialog.show(confirm).then(function () {
                            clear();
                        }, function () {
                            vm.cookie.save = true;
                            storage.save(vm.cookie);
                        });
                    }
                } else {
                    showAlert('Missing Info', 'Please enter a valid 10 digit phone number.');
                    vm.save = false;
                }
            } else {
                showAlert('Missing Info', 'Please enter your full name.');
                vm.save = false;
            }
        }

        function getItemInfo() {
            vm.showSpinner = true;
            var params = {
                x: vm.place.coord.x,
                y: vm.place.coord.y
            };
            assetFactory.processpole(params).then(function (response) {
                var data = response.data;
                if (data.title) {
                    vm.showSpinner = false;
                    showError(data);
                } else {
                    vm.showSpinner = false;
                    var address = data.address;
                    var poleref = vm.place.poleref;
                    var type = vm.place.type;
                    var title = '';
                    var content = '';

                    if (vm.asset === 'hydrant') {
                        title = 'Fire Hydrant Details';
                        content = "<b>Address:</b> " + address + "<br><b>Tag:</b> " + poleref;
                    } else {
                        title = 'Pole Details';
                        content = "<b>Address:</b> " + address + "<br><b>PoleRef:</b> " + poleref + "<br><b>Type:</b> " + type;
                    }

                    var alert = $mdDialog.alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title(title)
                        .htmlContent(content)
                        .ariaLabel('Error')
                        .ok('Close');
                    $mdDialog.show(alert);
                }
            }, function (err) {
                vm.showSpinner = false;
                showError(err);
            });
        }

        function yes() {

            vm.showSpinner = true;
            var params = {
                x: vm.place.coord.x,
                y: vm.place.coord.y
            };

            if (vm.type === 'Poles') {
                vm.issue = 'Poles';
            } else if (vm.place.type === 'STREET') {
                vm.issue = 'Streetlight';
            } else if (vm.place.type === 'SECURITY') {
                vm.issue = 'Securitylight';
            } else if (vm.place.type === 'ALLEY') {
                vm.issue = 'Alleylight'
            } else {
                vm.issue = 'Hydrant';
            }

            assetFactory.processpole(params).then(function (response) {
                vm.showSpinner = false;
                var data = response.data;
                if (data.title) {
                    showError(data);
                    if (isOpenLeft()) {
                        closeLeft();
                    }
                } else {
                    vm.place.address = data.address;
                    vm.map.hideInfoWindow('iw');
                    toggleLeft('left');
                    getCookie();
                }
            }, function (err) {
                vm.showSpinner = false;
                showError(err);
            });
        }

        function showDetail(e, place) {

            vm.place = place;
            var location = new google.maps.LatLng(place.position[0], place.position[1]);

            vm.map.panTo(location);
            vm.map.setZoom(19);

            if (place.reported) {
                vm.map.hideInfoWindow('iw');
                vm.map.showInfoWindow('reported', vm.place);
            } else {
                vm.map.hideInfoWindow('reported');
                vm.map.showInfoWindow('iw', vm.place);
            }
        }

        

        function goHome() {
            vm.map.hideInfoWindow('iw');
            vm.map.hideInfoWindow('reported');
            vm.positions = [];
            $state.go('assist');
        }

        function zoom() {
            vm.getAssets();
        }

        function dragend() {
            vm.getAssets();
        }

        function cancel() {
            vm.map.hideInfoWindow('iw');
            vm.positions = [];
            var confirm = $mdDialog.confirm({
                title: 'Confirm',
                textContent: 'Leave this page?',
                ok: 'Yes',
                cancel: 'Cancel'
            }).ariaLabel('Confirm');
            $mdDialog.show(confirm).then(function () {
                $state.go('assist');
            }, function () {});
        }

        function selectedItemChange(item) {

            if (item) {
                getDetails(item).then(function (details) {
                    var location = new google.maps.LatLng(details.geometry.location.lat(), details.geometry.location.lng());
                    vm.myPosition = [location.lat(), location.lng()];
                    vm.map.panTo(location);
                    vm.map.setZoom(19);
                    vm.getAssets();
                });
                vm.selectedItem = '';
            }
        }

        function showPrompt(ev) {

            var confirm = $mdDialog.prompt()
                .title('Enter a Tag Number')
                .placeholder('e.g. 123456')
                .ariaLabel('Pole Tag')
                .targetEvent(ev)
                .ok('Search')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function (result) {

                var p = new RegExp('^[0-9]+$');
                if (!p.test(result)) {
                    showError({
                        title: 'Error',
                        message: 'The Pole Tag is not valid.  Please validate the pole tag number.'
                    });
                } else {
                    vm.showSpinner = true;
                    var params = {
                        poletag: result,
                        type: vm.type
                    };
                    assetFactory.getPole(params).then(function (response) {
                        if (response.data.title === 'Error') {
                            vm.showSpinner = false;
                            showError(response.data);
                            return;
                        }
                        var data = response.data;
                        vm.showSpinner = false;
                        if (data.results === 0) {
                            showAlert(data.title, data.message);
                        } else {
                            plotSingle(data);
                        }
                    }, function (err) {
                        console.error(err);
                    });
                }
            }, function () {});
        }

        function search(address) {
            var deferred = $q.defer();
            getResults(address).then(
                function (predictions) {
                    var results = [];
                    for (var i = 0; i < predictions.length; i++) {
                        results.push(predictions[i]);
                    }
                    deferred.resolve(results);
                }
            );
            return deferred.promise;
        }

        function getResults(address) {
            var deferred = $q.defer();
            vm.gmapsService.getPlacePredictions({
                    input: address
                },
                function (data) {
                    deferred.resolve(data);
                });
            return deferred.promise;
        }

        function getDetails(place) {
            var deferred = $q.defer();
            vm.placeService.getDetails({
                'placeId': place.place_id
            }, function (details) {
                deferred.resolve(details);
            });
            return deferred.promise;
        }

        function getAssets() {

  console.log('-----------------------------------GetAssets----------------------------------------------')          if (vm.map.getZoom() >= 18 && vm.map.getBounds() !== undefined) {
                vm.showSpinner = true;
                var bound = vm.map.getBounds();
                var bounds = {
                    swlat: bound.getSouthWest().lat(),
                    swlng: bound.getSouthWest().lng(),
                    nelat: bound.getNorthEast().lat(),
                    nelng: bound.getNorthEast().lng(),
                    type: vm.type
                };

                assetFactory.getBoundsAssets(bounds).then(function (response) {

                    var data = response.data;

                    if (data.title === 'Error') {
                        vm.showSpinner = false;
                        showError(data);
                        return;
                    }

                    if (data.results === 0) {
                        vm.showSpinner = false;
                        return;
                    }

                    plot(data);
                    vm.showSpinner = false;

                }, function (err) {
                    vm.showSpinner = false;
                    showAlert("ERROR", "There was an error processing your request.  Please try again in a few minutes, we apologize for any inconvenience.")
                });
            }
        }

        function plotSingle(params) {

            if (vm.polepositions.length > 0) {
                for (var key in vm.map.markers) {
                    if (vm.map.markers[key].icon !== '/images/dist/ic_location.png')
                        vm.map.markers[key].setMap(null);
                }
                vm.polepositions = [];
            }

            for (var i = 0; i < params.length; i++) {
                var item = {
                    position: [params[i].lat, params[i].lng],
                    objectid: params[i].objectid,
                    poleref: params[i].pole,
                    coord: params[i].coord,
                    type: params[i].type,
                    reported: (params[i].reported !== undefined) ? params[i].reported : false,
                    requestid: params[i].request_id,
                    dtinit: params[i].dtinit,
                    status: params[i].status,
                    icon: (params[i].reported) ? vm.red : vm.blue,
                    zoom: params[i].zoom
                };
                vm.polepositions.push(item);
            }
            vm.map.setZoom(item.zoom);
        }

        function plot(params) {
            vm.clearMap();
            for (var i = 0; i < params.length; i++) {
                var item = {
                    position: [params[i].lat, params[i].lng],
                    objectid: params[i].objectid,
                    poleref: params[i].pole,
                    coord: params[i].coord,
                    type: params[i].type,
                    reported: (params[i].reported !== undefined) ? params[i].reported : false,
                    requestid: params[i].request_id,
                    dtinit: params[i].dtinit,
                    status: params[i].status,
                    icon: (params[i].reported) ? vm.red : vm.blue
                };
                vm.positions.push(item);
            }
        }

        function clearMap() {
            if (vm.positions !== undefined && vm.positions.length > 0) {
                for (var key in vm.map.markers) {
                    if (vm.map.markers[key].icon.url !== '/images/dist/ic_location.png') {
                        vm.map.markers[key].setMap(null);
                    }
                }
                vm.positions = [];
            }
        }
    };

    angular.module('bpub').controller('assetCtrl', ['$scope','$state','$mdToast','$timeout','$mdMedia','$mdDialog','$q','$mdSidenav','$stateParams','NgMap','assetFactory','storage',assetCtrl]);
})();
'use strict';
(function() {

    var issueCtrl = function ($scope, $state, $mdToast, $mdMedia, $mdDialog, $q, $timeout, $mdSidenav, $stateParams, NgMap, issueFactory, storage) {

        var vm = this;

        if ($stateParams.type === '') {
            $state.go('assist');
        }
        vm.tree = false;
        if ($stateParams.type == 'Tree'){
            vm.tree = true;
            vm.type = 'Electric';             
            vm.comments = "Tree limb on wire";                 
        }
        else{
        vm.type = $stateParams.type;
        }
        vm.showControl = false;
        vm.input = document.getElementById('autocomplete');
        NgMap.getMap().then(function (evt) {

            vm.map = evt;
            vm.map.setCenter(new google.maps.LatLng(25.9017, -97.4975));
            vm.map.setZoom(15);
            vm.IntroOptions = {
                steps: [{
                        element: document.querySelector('#gps'),
                        intro: '<p style="text-align: center;">Tap on this GPS icon to get your current location.  This functionality requires that location services are enabled on your device.</p>',
                        position: 'bottom-left-aligned'

                    },
                    {
                        element: document.querySelector('#address'),
                        intro: '<p style="text-align: center;">Or you can type in the affected address.  If you need additional assistance visit our <a href="/help">help center.</a></p>',
                        position: 'bottom-middle-aligned'

                    }
                ],
                showStepNumbers: false,
                exitOnOverlayClick: true,
                exitOnEsc: true,
                nextLabel: '<strong>Next</strong>',
                prevLabel: 'Prev',
                showBullets: false,
                doneLabel: '<strong>OK, Got It!</strong>'
            };

            $timeout(function () {
                vm.showControl = true;
                vm.map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('autocomplete'));
            }, 1500);
            google.maps.event.trigger(vm.map, 'resize');

        });
        $scope.$watch(function () {
            return $mdMedia('gt-md');
        }, function (obj) {
            vm.i = obj;
        });

        vm.issue = vm.type.toLowerCase();
        vm.isOpenLeft = isOpenLeft;
        vm.selectedItemChange = selectedItemChange;
        vm.search = search;
        vm.getIssueRadios = getIssueRadios;
        vm.cancel = cancel;
        vm.toggleLeft = toggleLeft('left');
        vm.closeInfWin = closeInfWin;
        vm.clicked = clicked;
        vm.yes = yes;
        vm.closeLeft = closeLeft;
        vm.saveInfo = saveInfo;
        vm.textMe = textMe;
        vm.voiceMe = voice;
        vm.getCookie = getCookie;
        vm.setIssue = setIssue;
        vm.submitForm = submitForm;
        vm.clickmarker = clickmarker;
        vm.getLocation = getLocation;
        vm.showError = showError;
        vm.showRem = showRem;
        vm.help = goHelp;
        vm.home = goHome;
        vm.multiunit = false;
        vm.submitDisabled = false;
        vm.update = false;
        vm.selected = false;
        vm.isDisabled = false;
        vm.isHiden = false;
        vm.showProgress = false;
        vm.showHints = true;
        vm.showTooltip = false;
        vm.lockedOpen = false;
        vm.certif = '';
        vm.location = '';
        vm.radio = '';
        vm.issueObj = {};
        vm.cookie = {};
        vm.result = [];
        vm.positions = [];
        vm.gis = {};
        vm.ShouldAutoStart = false;
        vm.issues = [];
        vm.showMessage = showMessage;
        vm.isDisabled = isDisabled;
        vm.isHidden = isHidden;
        vm.enable = enable;
        vm.change = change;
        vm.check = check;
        vm.issueList = {
            'electric': [{
                'display': 'No Lights',
                'value': 25,
                'disabled': true
            }, {
                'display': 'Voltage Problems',
                'value': 22,
                'disabled': true
            }, {
                'display': 'Wire Down',
                'value': 40,
                'disabled': false
            }, {
                'display': 'Car Hit Pole',
                'value': 12,
                'disabled': false
            }, {
                'display': 'Transformer Sparking',
                'value': 14272,
                'disabled': false
            }, {
                'display': 'Other Electric Issue',
                'value': 423,
                'disabled': false
            }],
            'water': [{
                'display': 'No Water',
                'value': 41,
                'disabled': true
            }, {
                'display': 'Low Water Pressure',
                'value': 14319,
                'disabled': true
            }, {
                'display': 'Bad Odor/Taste',
                'value': 14318,
                'disabled': true
            }, {
                'display': 'Dirty/Cloudy Water',
                'value': 14317,
                'disabled': true
            }, {
                'display': 'Service Line Broken',
                'value': 416,
                'disabled': false
            }, {
                'display': 'Other Water Issue',
                'value': 65,
                'disabled': false
            }],
            'wastewater': [{
                'display': 'Sewer Backup/Overflow',
                'value': 14308,
                'disabled': true
            }, {
                'display': 'Sewer Line Plugged',
                'value': 14309,
                'disabled': true
            }, {
                'display': 'Odor Complaint',
                'value': 51,
                'disabled': false
            }, {
                'display': 'Manhole Overflow',
                'value': 15317,
                'disabled': false
            }, {
                'display': 'Broken Line',
                'value': 55,
                'disabled': false
            }, {
                'display': 'Other Sewer Issue',
                'value': 415,
                'disabled': false
            }]
        };

        if (vm.type === 'Electric') {
            vm.issues = vm.issueList.electric;
        }

        if (vm.type === 'Water') {
            vm.issues = vm.issueList.water;
        }

        if (vm.type === 'WasteWater') {
            vm.issues = vm.issueList.wastewater;
        }

        function enable($event) {

            if (vm.type === 'Electric') {
                for (let i = 0; i < 2; i++) {
                    vm.issues[i].disabled = false;
                }  
                if (vm.tree){                    
                    vm.issues[0].hidden = true;
                    vm.issues[1].hidden = true;
                    vm.issues[2].hidden = true;
                    vm.issues[3].hidden = true;
                    vm.issues[4].hidden = true; 
                    vm.issues[5].hidden = true; 
                }              
            }

            if (vm.type === 'Water') {
                for (let i = 0; i < 4; i++) {
                    vm.issues[i].disabled = false;
                }
            }

            if (vm.type === 'WasteWater') {
                for (let i = 0; i < 2; i++) {
                    vm.issues[i].disabled = false;
                }
            }
        }

        function disable() {
            if (vm.type === 'Electric') {
                for (let i = 0; i < 2; i++) {
                    vm.issues[i].disabled = true;
                }
            }

            if (vm.type === 'Water') {
                for (let i = 0; i < 4; i++) {
                    vm.issues[i].disabled = true;
                }
            }

            if (vm.type === 'WasteWater') {
                for (let i = 0; i < 2; i++) {
                    vm.issues[i].disabled = true;
                }
            }
        }

        function isDisabled($event) {
            return $event;
        }

        function isHidden($event) {
            return $event;
        }

        function check() {            
            if (!vm.account) {
                showMessage('We apologize', 'Please enter your account number.', 'Missing account number');
                disable();
            } else {
                showMessage('Account number detected', 'Please continue to fill out the form.', 'Continue filling form');
                enable();
            }
        }

        function change() {
            if (vm.account) {
                enable();
            } else {
                disable();
                vm.radio = false;
            }
        }

        function showAdvanced(ev) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                templateUrl: '/templates/message.html',
                clickOutsideToClose: false,
                preserveScope: true,
                controller: ['$scope','$mdDialog', function MessageController($scope, $mdDialog) {
                    $scope.title = ev.notice.title;
                    $scope.header = ev.notice.header;
                    $scope.message = ev.notice.message;
                    $scope.close = function() {
                        $mdDialog.hide();
                    };
                }]
            });
        }

        function showRem() {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(true)
                .title('Remember Me')
                .textContent('When you opt in, you allow BPUB Assist to provide you with a more personalized experience.  If you check Rememeber Me, we will make it easier pre-populating fields you choose to save.  This option is NOT recommended if you are using a public or shared computer.')
                .ariaLabel('Remember Me')
                .ok('OK')
            );
        }

        function showMessage(title, text, aria) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(title)
                .textContent(text)
                .ariaLabel(aria)
                .ok('OK')
            );
        }

        function showError(error) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(error.title)
                .textContent(error.message)
                .ariaLabel('Error')
                .ok('OK');
            $mdDialog.show(alert).then(function () {
                $state.go('assist');
            });
        }

        function showAlert(title, text) {
            var alert = $mdDialog.alert({
                title: title,
                textContent: text,
                ok: 'OK'
            });
            $mdDialog.show(alert).finally(function () {
                alert = undefined;
            });
        }

        function goHelp() {
            vm.map.hideInfoWindow('iw');
            vm.positions = [];
            $state.go('help');
        }

        function goHome() {
            vm.map.hideInfoWindow('iw');
            vm.positions = [];
            $state.go('assist');
        }

        function setIssue() {
            
            if (vm.radio.value === 25 || vm.radio.value === 22 || vm.radio.value === 41) {
                if (vm.certif === true) {
                    vm.issueObj = {
                        value: vm.radio.value,
                        display: getDisplay(vm.radio.value)
                    };
                } else {
                    //Not serviced by BPUB
                    showMessage('Not Serviced', 'Brownsville PUB does not service this location', 'Not Serviced');
                    vm.radio = '';
                }
            } else {
                vm.issueObj = {
                    value: vm.radio.value,
                    display: getDisplay(vm.radio.value)
                };
            }
        }

        function clickmarker() {
            vm.myLocation = [];
        }

        function getLocation() {

            if (!navigator.geolocation) {
                showMessage('Error', 'Your browser is outdated and does not support Geolocation.  Please upgrade your browser or simply type in the affected address.', 'Error GPS');
                return;
            }

            var options = {
                enableHighAccuracy: true,
                timeout: 10000
            };

            function success(position) {
                var location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                vm.map.panTo(location);
                vm.map.setZoom(19);
                vm.radio = '';
                vm.positions = [];
                vm.positions.push([location.lat(), location.lng()]);
                vm.map.showInfoWindow('iw', location);
            }

            function error(err) {
                console.log(err);
                //supress Mozilla timeout
                if (err.code === 3)
                    return;

                showMessage('No GPS', 'Please check if you have GPS or location services enabled on your device, then restart your browser.', 'No GPS');
            }

            navigator.geolocation.getCurrentPosition(success, error, options);
        }

        function submitForm($event) {

            vm.submitDisabled = true;
            vm.showFrm = true;
            var cutoff = false;
            if (vm.tree){
                vm.issueObj = {
                    value: 26,
                    display: "Tree limb on wire"
                };
            }
            var serialized = {

                name: vm.name,
                phone: vm.phone,
                account: vm.account,
                email: vm.email === '' ? 'notvalid@brownsville-pub.com' : vm.email,
                comment: vm.comments,
                service_type: vm.type,
                text: vm.text,
                voice: vm.call,
                issue: vm.issueObj,
                gis: vm.gis
            };

            if (vm.apt) {
                serialized.gis.apt = vm.apt.aptno;
                serialized.srvl = vm.apt.srvl;
            }            
            
            if (vm.issueObj.value === 415 || vm.issueObj.value === 65 || vm.issueObj.value === 423) {
                if (!serialized.comment) {
                    showAlert("Comments", "Please provide us with your comments to better assist you.");
                    vm.radio = '';
                    vm.submitDisabled = false;
                    return;
                }
            }

            if (serialized.gis.id == 20616) {
                cutoff = true;
            }

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: false,
                scope: $scope,
                preserveScope: true,
                templateUrl: '/templates/dialog.html',
                controller: ['$scope', '$state', '$mdDialog', 'issueFactory', function DialogController($scope, $state, $mdDialog, issueFactory) {

                    $scope.cwJsonObj = serialized;
                    $scope.issueFact = issueFactory;
                    $scope.activated = true;
                    $scope.cutoff = cutoff;
                    $scope.error = false;
                    $scope.showOk = false;
                    $scope.showWait = true;
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                        $state.go('assist');
                    };

                    if (!cutoff) {

                        $scope.issueFact.process($scope.cwJsonObj).then(function (response) {

                            const data = response.data;

                            if (data.error) {
                                showError(data.error);
                                return;
                            }

                            if (data.notice) {
                                showAdvanced(data);
                                return;
                            }

                            if (data.limit_reached === true) {
                                $scope.limitReached = true;
                                $scope.showWait = false;
                                $scope.showOk = true;
                            } else if (data.address_reported === true) {
                                $scope.addressReported = true;
                                $scope.showWait = false;
                                $scope.showOk = true;
                            } else {
                                $scope.showWait = false;
                                $scope.activated = false;
                                $scope.id = data.id;
                                $scope.showOk = true;
                            }
                        }, function (err) {
                            if (err) {
                                //    console.log(err);
                            }
                            $scope.showWait = false;
                            $scope.error = true;
                            $scope.showOk = true;
                        });
                    } else {
                        $scope.showWait = false;
                        $scope.showOk = true;
                    }
                }]
            });
        }

        function yes(params) {

            vm.apt = '';
            vm.showProgress = true;
            params.push(vm.type);
            //Added CGM 2024-30-2024
            vm.issues[0].disabled = true;
            vm.issues[1].disabled = true; 
            //End CGM 2024-30-2024
            issueFactory.preprocess(params).then(function (response) {

                const data = response.data;

                if (data.error) {
                    vm.showProgress = false;
                    showError(data.error);
                    return;
                }

                if (data.notice) {
                    vm.showProgress = false;
                    showAdvanced(data);
                    return;
                }

                vm.multiunit = data.multi;
                vm.showProgress = false;
                vm.map.hideInfoWindow('iw');
                vm.certif = data.certif;
                vm.location = data.address;
                vm.gis = data;
                if (!vm.isOpenLeft()) {
                    vm.toggleLeft();
                    getCookie();
                    vm.aptlist = [];
                    if (data.aptlist.length === 0) {
                        vm.aptlist = data.aptlist;
                        if (vm.account) {
                            enable();
                        } else {
                            disable();
                        }
                    } else if (data.aptlist.length === 1) {
                        vm.srvl = data.aptlist[0].srvl;
                        if (vm.account || data.aptlist[0].srvl) {
                            enable();
                        }
                    } else if (data.aptlist.length > 1) {
                        vm.aptlist = data.aptlist;
                        if (vm.account) {
                            enable();
                        }
                    }
                }
            }, function (err) {
                console.error(err);
            });
        }

        function clicked(event) {
            vm.radio = '';
            vm.positions = [];
            vm.positions.push([event.latLng.lat(), event.latLng.lng()]);
            vm.map.panTo(event.latLng);
            vm.map.showInfoWindow('iw', event.latLng);
        }

        function getCookie() {

            vm.cookie = storage.getAll();
            if (vm.cookie !== null) {
                if (vm.cookie.tutorial) {
                    promptTutorial();
                } else {
                    vm.name = vm.cookie.name;
                    vm.phone = vm.cookie.phone;
                    vm.account = vm.cookie.account;
                    vm.email = vm.cookie.email;
                    vm.tutorial = vm.cookie.tutorial;
                    vm.save = (vm.cookie.name && vm.cookie.phone) ? vm.cookie.save : false;
                    vm.text = (vm.cookie.phone) ? vm.cookie.text : false;
                    if (vm.cookie.call === undefined) {
                        vm.cookie.call = false;
                        vm.call = false;
                        storage.save(vm.cookie);
                    } else {
                        vm.call = (vm.cookie.phone) ? vm.cookie.call : false;
                    }

                }
            } else {
                promptTutorial();
            }
        }

        function clear() {
            var tmp = storage.getAll();
            for (var key in tmp) {
                if (key === 'name' || key === 'phone' || key === 'account' || key === 'email' || key === 'save' || key === 'text' || key === 'call') {
                    delete tmp[key];
                }
            }
            vm.name = '';
            vm.phone = '';
            vm.account = '';
            vm.email = '';
            vm.save = false;
            vm.text = false;
            vm.call = false;
            vm.cookie = tmp;
            change();
            storage.save(vm.cookie);
        }

        function promptTutorial() {
            var confirm = $mdDialog.confirm()
                .title('Welcome')
                .textContent("Looks like you haven't been here before, would you like some help getting started?")
                .ariaLabel('Confirm')
                .ok("Yes!")
                .cancel('No, Thanks');
            $mdDialog.show(confirm).then(function () {
                vm.cookie.tutorial = false;
                storage.save(vm.cookie);
                $scope.CallMe();
            }, function () {
                vm.cookie.tutorial = false;
                storage.save(vm.cookie);
            });
        }

        function saveInfo() {

            if (vm.name) {
                if (vm.phone) {
                    if (vm.save) {
                        vm.cookie.name = vm.name;
                        vm.cookie.phone = vm.phone;
                        vm.cookie.account = vm.account;
                        vm.cookie.email = vm.email;
                        vm.cookie.save = vm.save;
                        vm.cookie.text = vm.text;
                        vm.cookie.call = vm.call;
                        storage.save(vm.cookie);
                    } else {
                        var confirm = $mdDialog.confirm()
                            .title('Confirm')
                            .textContent('Are you sure you wish to remove saved information?')
                            .ariaLabel('Confirm deletion')
                            .ok('Yes')
                            .cancel('No');
                        $mdDialog.show(confirm).then(function () {
                            clear();
                        }, function () {
                            vm.cookie.save = true;
                            storage.save(vm.cookie);
                        });
                    }
                } else {
                    showAlert('Missing Info', 'Please enter a valid 10 digit phone number.');
                    vm.save = false;
                }
            } else {
                showAlert('Missing Info', 'Please enter your full name.');
                vm.save = false;
            }

        }

        function textMe() {
            console.log('vm.phone', vm.phone);
            if (vm.phone === undefined || vm.phone === '') {
                showAlert('Missing Info', 'Please enter a valid 10 digit phone number.');
                vm.text = false;
            } else {
                if (!vm.text) {

                    var confirm = $mdDialog.confirm()
                        .title('Confirm')
                        .textContent("Are you sure you do not want to be notified via Text?")
                        .ariaLabel('Confirm')
                        .ok("Yes, I'm sure")
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function () {
                        vm.cookie.text = false;
                        storage.save(vm.cookie);
                    }, function () {
                        vm.cookie.text = true;
                        storage.save(vm.cookie);
                    });
                } else {
                    vm.cookie.text = true;
                    storage.save(vm.cookie);
                }
            }
        }

        function voice() {
            if (vm.phone === undefined || vm.phone === '') {
                showAlert('Missing Info', 'Please enter a valid 10 digit phone number.');
                vm.call = false;
            } else {
                if (!vm.call) {
                    var confirm = $mdDialog.confirm()
                        .title('Confirm')
                        .textContent("Are you sure you do not want to be notified via voice call?")
                        .ariaLabel('Confirm')
                        .ok("Yes, I'm sure")
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function () {
                        vm.cookie.call = false;
                        storage.save(vm.cookie);
                    }, function () {
                        vm.cookie.call = true;
                        storage.save(vm.cookie);
                    });
                } else {
                    vm.cookie.call = true;
                    storage.save(vm.cookie);
                }
            }
        }

        function isOpenLeft() {
            return $mdSidenav('left').isOpen();
        }

        function closeLeft() {

            if (vm.isOpenLeft()) {

                $mdSidenav('left').close();
            }
        }

        function toggleLeft(navID) {
            return function () {
                $mdSidenav(navID).toggle();
            }
        }

        function closeInfWin() {

            vm.map.hideInfoWindow('iw');
            vm.location = '';
            $mdToast.show(
                $mdToast.simple()
                .textContent('Drag the map and then tap on the correct location.')
                .position('bottom')
                .hideDelay(7000)
            );
        }

        function getIssueRadios() {
            if (vm.issue === 'electric') {
                return vm.issueList.electric;
            } else if (vm.issue === 'water') {
                return vm.issueList.water;
            } else if (vm.issue === 'wastewater') {
                return vm.issueList.wastewater;
            }
        }

        function selectedItemChange(item) {
            if (item === undefined) {
                if (vm.selected) {
                    vm.selected = false;
                }
                return;
            }

            if (!vm.selected) {
                vm.positions = [];
                vm.map.setZoom(19);
                vm.map.setCenter(new google.maps.LatLng(item.geometry.lat, item.geometry.lng));
                vm.positions.push([item.geometry.lat, item.geometry.lng]);
                vm.map.showInfoWindow('iw');
            }
            vm.selected = true;
        }

        function search(address) {

            let reg = new RegExp(/^[0-9a-zA-Z\s]+$/);
            if (address.length === 0) {
                return;
            }
            if (!reg.test(address)) {
                return [];
            }

            var deferred = $q.defer();

            getResults(address)
                .then(function (predictions) {

                    if (predictions === null)
                        return;

                    var results = [];
                    for (var i = 0; i < predictions.length; i++) {
                        results.push(predictions[i]);
                    }
                    deferred.resolve(results);
                });

            return deferred.promise;
        }

        function getResults(address) {

            var deferred = $q.defer();

            issueFactory.addressQuery(address).then(function (response) {
                deferred.resolve(response.data);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function cancel() {

            vm.map.hideInfoWindow('iw');
            vm.positions = [];
            var confirm = $mdDialog.confirm()
                .title('Confirm')
                .textContent("Leave this page?")
                .ariaLabel('Confirm')
                .ok("Yes")
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                $state.go('assist');
            }, function () {});
        }

        function getDisplay(value) {

            if (vm.type === 'Electric') {
                var el = vm.issueList.electric.filter(getDisplayByValue, value)[0];
                return el.display;
            }

            if (vm.type === 'Water') {
                var wa = vm.issueList.water.filter(getDisplayByValue, value)[0];
                return wa.display;
            }

            if (vm.type === 'WasteWater') {
                var ww = vm.issueList.wastewater.filter(getDisplayByValue, value)[0];
                return ww.display;
            }
        }

        function getDisplayByValue(obj) {

            var t = Object(this);
            if (obj.value == t) {
                return obj;
            }
        }

    };

    angular.module('bpub').controller('issueCtrl', ['$scope', '$state', '$mdToast', '$mdMedia', '$mdDialog', '$q', '$timeout', '$mdSidenav', '$stateParams', 'NgMap', 'issueFactory', 'storage', issueCtrl]);
})();
'use strict';
(function() {
    
    var helpCtrl = function ($state, $mdDialog) {

        ContactController.$inject = ["$scope", "$mdDialog"];
        var vm = this;

        vm.goHome = goHome;
        vm.contact = contact;

        function contact(ev) {

            console.log('contact');

            $mdDialog.show({
                controller: ContactController,
                templateUrl: '/templates/contact.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (formValues) {
                //TODO: send feedback to api
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(false)
                        .textContent('Thank you for your comments.')
                        .ariaLabel('Thank you')
                        .ok('OK')
                );
                console.log(formValues);
            }, function () {
                //Do nothing, user canceled
            });
        }

        function goHome() {

            $state.go('assist');
        }

        function ContactController($scope, $mdDialog) {

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.formsubmit = function () {

                var formValues = {
                    name: $scope.name,
                    email: $scope.email,
                    comment: $scope.comment
                }

                $mdDialog.hide(formValues);
            };
        }
    }
    helpCtrl.$inject = ["$state", "$mdDialog"];

    angular.module('bpub').controller('helpCtrl', helpCtrl);
})();
'use strict';
(function() {
    const termsCtrl = function($scope, $window) {
        let vm = this;
        vm.goHome = goHome;

        const goHome = function() {
            $state.go('assist');
        }
    };
    termsCtrl.$inject = ["$scope", "$window"];

    angular.module('bpub').controller('termsCtrl', termsCtrl);
})();
'use strict';
(function() {
    const privacyCtrl = function($scope, $window) {
        const vm = this;
        vm.goHome = goHome;

        const goHome = function() {
            $state.go('assist');
        }
    };
    privacyCtrl.$inject = ["$scope", "$window"];

    angular.module('bpub').controller('privacyCtrl', privacyCtrl);
})();
(function() {
	var assistFactory = function($http) {
		var factory = {};
		factory.tweets = function() {
			return $http({
				method: 'get',
				url: '/tweet.json'
			});
		};

		factory.maintenance = function() {
			return $http({
				method: 'get',
				url: '/maintenance.json'
			});
		};

		factory.trash = function(params) {
			return $http({
				method: 'post',
				data: {
					params: params
				},
				url: "https://assist.brownsville-pub.com/api/cob"
			});
		};

		return factory;
	};
	angular.module('bpub').factory('assistFactory', ['$http',assistFactory]);
})();
(function() {
	const assetFactory = function($http) {
		const factory = {};

		factory.getPole = function(params) {
			return $http({
				method: 'post',
				data: params,
				url: "https://assist.brownsville-pub.com/api/getpole"

			});
		};

		factory.process = function(params) {
			return $http({
				method: 'post',
				data: params,
				url: "https://assist.brownsville-pub.com/api/processasset"
			});
		};

		factory.processpole = function(params) {
			return $http({
				method: 'post',
				data: {
					'xy': params
				},
				url: "https://assist.brownsville-pub.com/api/processpole"
			});
		};

		factory.getBoundsAssets = function(params) {
			return $http({
				method: 'post',
				data: params,
				url: "https://api.brownsville-pub.com/api/getassets"
			});
		};

		return factory;
	};
	angular.module('bpub').factory('assetFactory', ['$http',assetFactory]);
})();
(function() {
	var issueFactory = function($http) {

		var factory = {};

		factory.addressQuery = function(params) {

			return $http({
				method: 'post',
                data: { 'params': params.toUpperCase() },
                url: "https://assist.brownsville-pub.com/api/address" 

			});
		};

        factory.preprocess =  function(params) {
            return $http({
                method: 'post',
                data: {params: params},
                url: "https://assist.brownsville-pub.com/api/preprocess"
            });
        };

        factory.process = function(params) {

            return $http({
                method: 'post',
                data: {params: params},
                url: "https://assist.brownsville-pub.com/api/processissue"
            });
        };
        
		return factory;
	};
	angular.module('bpub').factory('issueFactory', ['$http',issueFactory]);
})();
(function() {

    var storage = function() {

      let factory = {};
      let appId = 'assist.brownsville-pub.com';

      factory.add = function(params) {
          let obj = JSON.parse(params);
          let tmp = JSON.parse(localStorage.getItem(appId));
          Object.keys(obj).forEach(function(key) {
             tmp[key] = obj[key];
          });
          localStorage.setItem(appId,JSON.stringify(tmp));
      };

      factory.set = function(key, value) {
          let tmp = JSON.parse(localStorage.getItem(appId));
          tmp[key] = value;
          localStorage.setItem(appId, JSON.stringify(tmp));
      };

      factory.new = function() {
          localStorage.setItem(appId, JSON.stringify({}));
      };

      factory.getItem = function(key) {
          let tmp = JSON.parse(localStorage.getItem(appId));
          return  { key: tmp[key] };
      };

      factory.getAll = function() {
          return JSON.parse(localStorage.getItem(appId));
      };

      factory.update = function(params) {
          let tmp = JSON.parse(localStorage.getItem(appId));
          Object.keys(params).forEach(function(key) {
             tmp[key] = params[key];
          });
      };

      factory.save = function(obj) {
          localStorage.setItem(appId, JSON.stringify(obj));
      };

      return factory;
    };

    angular.module('bpub').factory('storage', storage);
})();